import classNames from "classnames";
import { Link } from "react-router-dom";

export default function Logo({ center = false, className, size = "225px" }) {
  const classes = classNames(
    {
      "mx-auto d-block": center, // Add d-block for block-level behavior
    },
    className
  );

  return (
    <Link to="/">
      <img src="/logo.png" alt="Logo" width={size} className={classes} />
    </Link>
  );
}
